/* eslint-disable @typescript-eslint/no-empty-interface */
import { createTheme } from '@material-ui/core';

import palette, { CustomPalette } from './palette';
import typography from './typography';
import overrides from './overrides';



declare module '@material-ui/core/styles/createPalette' {
  export interface PaletteOptions extends CustomPalette {}
  export interface Palette extends CustomPalette {}
}

const theme = {
  palette,
  typography,
  overrides
} as const;

export default createTheme(theme);
